const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');

const NotFoundPage = component(() => {
  return {
    view: () => m('section.panel.not-found-page',
      m(Breadcrumbs, { items: [
        { label: 'Sites', href: '/sites' },
        { label: 'Page not found' }
      ] }),
      m('h2', 'Page not found'),
      m('p', 'This page does not exist in Spache.'),
      m('a.button', { href: '/sites' }, 'Go to your sites')
    )
  };
});

const AccessDeniedPage = component(() => {
  return {
    view: () => m('section.panel.not-found-page',
      m(Breadcrumbs, { items: [
        { label: 'Sites', href: '/sites' },
        { label: 'Administrator access required' }
      ] }),
      m('h2', 'Administrator access required'),
      m('p', 'This account does not have the Spache administrator role.'),
      m('a.button', { href: '/sites' }, 'Go to your sites')
    )
  };
});

module.exports = { AccessDeniedPage, NotFoundPage };
